import Performance from './Performance.js'

class PerformanceStore {
  static #KEY = "gimePerformances"

  static create(performance) {
    const all = PerformanceStore.#load()
    performance.id = crypto.randomUUID()
    all.push(performance)
    PerformanceStore.#save(all)
    return performance
  }

  static getForWorkout(workout) {
    return PerformanceStore.#load().filter(performance => performance.workoutId === workout.id)
  }

  static getLatestForExercise(exerciseId) {
    const completed = PerformanceStore.#load()
      .filter(performance => performance.exerciseId === exerciseId && performance.completedAt)
    completed.sort((a, b) => new Date(b.completedAt) - new Date(a.completedAt))
    return completed[0] ?? null
  }

  static #load() {
    try {
      return JSON.parse(localStorage.getItem(PerformanceStore.#KEY) ?? "[]").map(object => new Performance(object))
    } catch {
      return []
    }
  }

  static #save(data) {
    localStorage.setItem(PerformanceStore.#KEY, JSON.stringify(data))
  }
}

export default PerformanceStore
